import {configureStore} from '@reduxjs/toolkit';
import mediaReducer from './slices/media';
import uploadReducer from './slices/upload';
import editorReducer from './slices/editor';
import chatReducer from './slices/chat';
import fsReducer from './slices/fs';
import encoderReducer from './slices/encoder';
import uiReducer from './slices/ui';
import auction from './slices/auction';
import folders from './slices/folders';
import shop from './slices/shop';
import camera from './slices/camera';
export const store = configureStore({
  reducer: {
    media: mediaReducer,
    upload: uploadReducer,
    encoder: encoderReducer,
    chat: chatReducer,
    fs: fsReducer,
    editor: editorReducer,
    ui: uiReducer,
    auction,
    folders,
    shop,
    camera,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
